// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2Y4DT","question":"Question_question__3YBCY","description":"Question_description__1OJ53"};